export const SIZE_SM = 16;
export const SIZE_MD = 20;
export const SIZE_LG = 24;

export const ICON_SIZE_PX = {
  sm: SIZE_SM,
  md: SIZE_MD,
  lg: SIZE_LG
};
